import request from '@/utils/request'
import axios from "axios";

export function addProduct(data) {
    return request({
        url: '/produce/add',
        method: 'post',
        data
    })
}

export function getProductList(params) {
    return request({
        url: '/produce/all',
        method: 'get',
        params
    })
}
export function getAllProducts(params) {
    return request({
        url: '/produce/all-own',
        method: 'get',
        params
    })
}

export function updateProduct(data) {
    return request({
        url: '/produce/update',
        method: 'post',
        data
    })
}

export function batchUpdateProducts(data) {
    return request({
        url: '/produce/batchUpdate',
        method: 'post',
        data
    })
}

export function importProducts(data) {
    return request({
        url: '/produce/import',
        method: 'post',
        data,
    })
}

export function getInboundList(params) {
    return request({
        url: '/inbound/all',
        method: 'get',
        params
    })
}

export function updateInbound(data) {
    return request({
        url: '/inbound/update',
        method: 'post',
        data
    })
}

export function submitReceipt(data) {
    return request({
        url: '/inbound/submitReceipt',
        method: 'post',
        data
    })
}

export function createPutawayOrder(data) {
    return request({
        url: '/putaway/createPutawayOrder',
        method: 'post',
        data
    })
}

export function getPutawayOrderList(params) {
    return request({
        url: '/putaway/getPutawayOrder',
        method: 'get',
        params
    })
}

export function updatePutawayOrderItem(data) {
    return request({
        url: '/putaway/updatePutawayOrderitem',
        method: 'post',
        data
    })
}

/*
export function importProducts(data) {
    const instance = axios.create();
    return instance({
        url: process.env.VUE_APP_BASE_API + '/produce/import',
        method: 'post',
        data,
    });
}*/
export function getOrderWithItemsPage(params) {
    return request({
        url: '/orders/getOrderWithItemsPage',
        method: 'get',
        params
    })
}

// 创建订单
export function createOrderWithItems(data) {
    return request({
        url: '/orders/createOrderWithItems',
        method: 'post',
        data
    })
}

// 根据订单号查询订单详情（用于按单打包，不需要用户ID）
export function getOrderByOrderNo(orderNo) {
    return request({
        url: '/orders/getOrderByOrderNo',
        method: 'get',
        params: {
            orderNo: orderNo
        }
    })
}

export function createPickOrders(data) {
    return request({
        url: '/pickOrder/create',
        method: 'post',
        data
    })
}

export function updateOrder(data) {
    return request({
        url: '/orders/updateOrder',
        method: 'post',
        data
    })
}

// 根据订单号更新订单状态（用于打包完成后更新状态为已发货）
export function updateOrderState(orderNo, state) {
    return request({
        url: '/orders/updateOrderState',
        method: 'post',
        params: { orderNo, state }
    })
}

// 提交订单（更新状态为待审核，并计算费用）
export function submitOrder(orderNo) {
    return request({
        url: '/orders/submitOrder',
        method: 'post',
        params: { orderNo }
    })
}

// 提交并审核订单（更新状态为待发货，并计算费用）
export function submitAndApproveOrder(orderNo) {
    return request({
        url: '/orders/submitAndApproveOrder',
        method: 'post',
        params: { orderNo }
    })
}

// 获取仓库列表
export function getWarehouseList(params) {
    return request({
        url: '/warehouse/list',
        method: 'get',
        params
    })
}

// 获取物流产品列表
export function getLogisticsProductList(params) {
    return request({
        url: '/logisticsProduct/list',
        method: 'get',
        params
    })
}

export function getPickOrderMainList(params) {
    return request({
        url: '/pickOrderMain/list',
        method: 'get',
        params
    })
}

export function getPickOrders(params) {
    return request({
        url: '/pickOrder/getPickOrders',
        method: 'get',
        params
    })
}

// 查询拣货单详情（包含订单号），用于按SKU打包
export function getPickOrdersWithOrderNo(params) {
    return request({
        url: '/pickOrder/getPickOrdersWithOrderNo',
        method: 'get',
        params
    })
}

// 获取二次分拣数据
export function getSecondaryPickingData(params) {
    return request({
        url: '/pickOrder/getSecondaryPickingData',
        method: 'get',
        params
    })
}

// 按SKU查询一票一件的拣货单
export function getOneTicketOneItemBySku(params) {
    return request({
        url: '/pickOrder/getOneTicketOneItemBySku',
        method: 'get',
        params
    })
}

// 新增：为拣货单分配配货员
export function assignPickers(data) {
    return request({
        url: '/pickOrderMain/assignPicker',
        method: 'post',
        data
    })
}

// 获取用户列表（用于选择配货员）
export function getUserList(params) {
    return request({
        url: '/wms/user/list',
        method: 'get',
        params
    })
}


export function createPackageMaterial(data) {
    return request({
        url: '/packageMaterial/create',
        method: 'post',
        data
    })
}

export function getPackageMaterial(params) {
    return request({
        url: '/packageMaterial/list',
        method: 'get',
        params
    })
}

export function createOrdersProduce(data) {
    return request({
        url: '/package/orders',
        method: 'post',
        data
    })
}

export function getPackageMaterialLog(params) {
    return request({
        url: '/packageMaterial/log',
        method: 'get',
        params
    })
}

export function addLogisticsProvider(data) {
    return request({
        url: '/logisticsProvider/add',
        method: 'post',
        data
    })
}

export function getLogisticsProviders(params) {
    return request({
        url: '/logisticsProvider/list',
        method: 'get',
        params
    })
}

export function updateLogisticsProvider(data) {
    return request({
        url: '/logisticsProvider/update',
        method: 'post',
        data
    })
}

export function addLogisticsChannel(data) {
    return request({
        url: '/logisticsChannel/add',
        method: 'post',
        data
    })
}

export function getLogisticsChannels(params) {
    return request({
        url: '/logisticsChannel/list',
        method: 'get',
        params
    })
}

export function getAllLogisticsChannels(params) {
    return request({
        url: '/logisticsChannel/list/all',
        method: 'get',
        params
    })
}

export function updateLogisticsChannel(data) {
    return request({
        url: '/logisticsChannel/update',
        method: 'post',
        data
    })
}

export function addLogisticsTemplate(data) {
    return request({
        url: '/logisticsTemplate/add',
        method: 'post',
        data
    })
}

export function getLogisticsTemplates(params) {
    return request({
        url: '/logisticsTemplate/list',
        method: 'get',
        params
    })
}
export function getActiveLogisticsTemplatesList(){
    return request({
        url: '/logisticsTemplate/listActive',
        method: 'get',
    })
}

export function updateLogisticsTemplate(data) {
    return request({
        url: '/logisticsTemplate/update',
        method: 'post',
        data
    })
}

export function batchAuditLogisticsTemplate(data) {
    return request({
        url: '/logisticsTemplate/batchAudit',
        method: 'post',
        data
    })
}

export function addWeightSegment(data) {
    return request({
        url: '/weightSegment/add',
        method: 'post',
        data
    })
}

export function getWeightSegments(params) {
    return request({
        url: '/weightSegment/list',
        method: 'get',
        params
    })
}

export function updateWeightSegment(data) {
    return request({
        url: '/weightSegment/update',
        method: 'post',
        data
    })
}

export function deleteWeightSegment(id) {
    return request({
        url: `/weightSegment/delete/${id}`,
        method: 'delete'
    })
}

export function importWeightSegmentByExcel(file, logisticsTemplateId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('logisticsTemplateId', logisticsTemplateId);
    return request({
        url: '/weightSegment/import/excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function downloadWeightSegmentTemplate() {
    window.open(`${process.env.VUE_APP_BASE_API}/weightSegment/download/template`, '_blank');
}

export function addLogisticsProduct(data) {
    return request({
        url: '/logisticsProduct/add',
        method: 'post',
        data
    })
}

export function getLogisticsProducts(params) {
    return request({
        url: '/logisticsProduct/list',
        method: 'get',
        params
    })
}

export function getActiveLogisticsProducts() {
    return request({
        url: '/logisticsProduct/listActive',
        method: 'get',
    })
}

export function updateLogisticsProduct(data) {
    return request({
        url: '/logisticsProduct/update',
        method: 'post',
        data
    })
}

export function deleteLogisticsProduct(id) {
    return request({
        url: `/logisticsProduct/delete/${id}`,
        method: 'delete'
    })
}

export function addShippingPartitionScheme(data) {
    return request({
        url: '/ShippingPartitionScheme/add',
        method: 'post',
        data
    })
}

export function getShippingPartitionSchemes(params) {
    return request({
        url: '/ShippingPartitionScheme/list',
        method: 'get',
        params
    })
}

export function getActiveShippingPartitionSchemes() {
    return request({
        url: '/ShippingPartitionScheme/listActive',
        method: 'get',
    })
}
export function updateShippingPartitionScheme(data) {
    return request({
        url: '/ShippingPartitionScheme/update',
        method: 'post',
        data
    })
}

export function batchAuditShippingPartitionScheme(data) {
    return request({
        url: '/ShippingPartitionScheme/batchAudit',
        method: 'post',
        data
    })
}

export function addShippingChargePartition(data) {
    return request({
        url: '/ShippingChargePartition/add',
        method: 'post',
        data
    })
}

export function getShippingChargePartitions(id) {
    return request({
        url: `/ShippingChargePartition/get/${id}`,
        method: 'get'
    })
}

export function getShippingChargePartitionsPaged(id, current = 1, size = 50) {
    return request({
        url: `/ShippingChargePartition/page/${id}`,
        method: 'get',
        params: { current, size }
    })
}

export function updateShippingChargePartition(data) {
    return request({
        url: '/ShippingChargePartition/update',
        method: 'post',
        data
    })
}

export function deleteShippingChargePartition(id) {
    return request({
        url: `/ShippingChargePartition/delete/${id}`,
        method: 'delete'
    })
}

export function batchAddShippingChargePartition(data) {
    return request({
        url: '/ShippingChargePartition/batchAdd',
        method: 'post',
        data
    })
}

export function importPartitionByExcel(file, schemeId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('schemeId', schemeId);
    return request({
        url: '/ShippingChargePartition/import/excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function downloadPartitionTemplate() {
    window.open(`${process.env.VUE_APP_BASE_API}/ShippingChargePartition/download/template`, '_blank');
}

export function addPostalCodeRange(data) {
    return request({
        url: '/PostalCodeRange/add',
        method: 'post',
        data
    })
}

export function getPostalCodeRanges(id) {
    return request({
        url: `/PostalCodeRange/get/${id}`,
        method: 'get'
    })
}

export function getPostalCodeRangesPaged(partitionId, current = 1, size = 50) {
    return request({
        url: `/PostalCodeRange/page/${partitionId}`,
        method: 'get',
        params: { current, size }
    })
}

export function updatePostalCodeRange(data) {
    return request({
        url: '/PostalCodeRange/update',
        method: 'post',
        data
    })
}

export function deletePostalCodeRange(id) {
    return request({
        url: `/PostalCodeRange/delete/${id}`,
        method: 'delete'
    })
}

export function deletePostalCodeRangesBatch(ids) {
    return request({
        url: '/PostalCodeRange/delete/batch',
        method: 'delete',
        data: ids
    })
}

export function importPostalCodeByExcel(file) {
    const formData = new FormData();
    formData.append('file', file);
    return request({
        url: '/PostalCodeRange/import/excel',
        method: 'post',
        data: formData
    })
}

export function downloadPostalCodeTemplate() {
    window.open(`${process.env.VUE_APP_BASE_API}/PostalCodeRange/download/template`, '_blank');
}

export function getPriceCombination(params) {
    return request({
        url: '/logisticsPriceScheme/getPriceCombination',
        method: 'get',
        params
    })
}

export function addLogisticsPriceSchemeWithPrice(data) {
    return request({
        url: '/logisticsPriceScheme/addLogisticsPriceSchemeWithPrice',
        method: 'post',
        data
    })
}

//查询操作费
export function queryOperatingFeesWithGroud(data) {
    return request({
        url: '/lws/fees/grounList',
        method: 'post',
        data,
        headers: {
            repeatSubmit: false  // 查询操作允许重复提交
        }
    })
}

//查询操作费
export function queryOperatingFees(data) {
    return request({
        url: '/lws/fees/list',
        method: 'post',
        data,
        headers: {
            repeatSubmit: false  // 查询操作允许重复提交
        }
    })
}

//保存操作费
export function addOperatingFees(data) {
    return request({
        url: '/lws/fees/add',
        method: 'post',
        data
    })
}

//批量审核操作费
export function batchAuditOperatingFees(data) {
    return request({
        url: '/lws/fees/batchAudit',
        method: 'post',
        data
    })
}

//更新操作费
export function updateOperatingFees(data) {
    return request({
        url: '/lws/fees/update',
        method: 'post',
        data
    })
}

//删除操作费
export function deleteOperatingFees(data) {
    return request({
        url: '/lws/fees/delete',
        method: 'post',
        data
    })
}

//导入操作费Excel
export function importOperatingFeesExcel(formData) {
    return request({
        url: '/lws/fees/import/excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

//下载操作费模板
export function downloadOperatingFeesTemplate() {
    window.open(`${process.env.VUE_APP_BASE_API}/lws/fees/download/template`, '_blank');
}

export function getLogisticsPriceSchemeList(params) {
    return request({
        url: '/logisticsPriceScheme/getLogisticsPriceSchemeList',
        method: 'get',
        params
    })
}

export function getLogisticsPriceByPriceSchemeId(priceSchemeId) {
    return request({
        url: '/logisticsPrice/getByPriceSchemeId',
        method: 'get',
        params: {
            priceSchemeId: priceSchemeId  // 传递价格方案ID参数
        }
    })
}

export function updateLogisticsPriceSchemeWithPrice(data) {
    return request({
        url: '/logisticsPriceScheme/updateLogisticsPriceSchemeWithPrice',
        method: 'post',
        data
    })
}

export function batchUpdateStatus(data) {
    return request({
        url: '/logisticsPriceScheme/batch/updateStatus',
        method: 'post',
        data
    })
}

export function calculateCost(params) {
    return request({
        url: '/logisticsPriceScheme/calculateCost',
        method: 'get',
        params
    })
}

// 新增：下载价格模板接口
export function downloadPriceTemplate(params) {
    return request({
        url: '/logisticsPrice/download-template', // 注意：URL 应与后端 Controller 中定义的一致
        method: 'get',
        params,
        // 关键：告诉 axios 这是一个二进制流响应，不要尝试解析成 JSON
        responseType: 'blob'
    })
}

export function buildDownloadTemplateUrl(params) {
    const baseUrl = '/logisticsPrice/download-template';
    const queryString = new URLSearchParams(params).toString();
    return `${baseUrl}?${queryString}`;
}

export function addFeeType(data) {
    return request({
        url: '/feeType/add',
        method: 'post',
        data
    })
}

export function getFeeTypeList(params) {
    return request({
        url: '/feeType/list',
        method: 'get',
        params
    })
}

export function updateFeeType(data) {
    return request({
        url: '/feeType/update',
        method: 'post',
        data
    })
}

export function addOverLengthWeightRule(data) {
    return request({
        url: '/overLengthWeightRule/add',
        method: 'post',
        data
    })
}

export function listOverLengthWeightRule(params) {
    return request({
        url: '/overLengthWeightRule/list',
        method: 'get',
        params
    })
}

export function updateOverLengthWeightRule(data) {
    return request({
        url: '/overLengthWeightRule/update',
        method: 'post',
        data
    })
}

export function getBillRuleDetail(id) {
    return request({
        url: `/overLengthWeightRule/getBillRuleDetail/${id}`,
        method: 'get'
    })
}

export function batchUpdateOverLengthWeightRule(data) {
    return request({
        url: '/overLengthWeightRule/batchUpdateStatus',
        method: 'post',
        data
    })
}

/**
 * 新增物流特殊费用（含明细）
 * @param {Object} data - 特殊费用信息（LogisticsSpecialFee 对象，含 specialFeeDetails 明细列表）
 * @returns {Promise} - 请求结果
 */
export function addLogisticsSpecialFee(data) {
    return request({
        url: '/logisticsSpecialFee/add',
        method: 'post',
        data
    })
}

/**
 * 分页查询物流特殊费用列表
 * @param {Object} params - 查询参数（LogisticsSpecialFeeQuery 对象）
 * @param {number} params.current - 当前页
 * @param {number} params.size - 每页条数
 * @param {number} [params.status] - 状态（0-未发布，1-已发布）
 * @param {string} [params.logisticsProductId] - 物流产品ID
 * @param {string} [params.location] - 计费地点（模糊查询）
 * @param {string} [params.startTime] - 生效时间（起始，格式：yyyy-MM-dd HH:mm:ss）
 * @param {string} [params.endTime] - 失效时间（结束，格式：yyyy-MM-dd HH:mm:ss）
 * @returns {Promise} - 分页查询结果
 */
export function listLogisticsSpecialFee(params) {
    return request({
        url: '/logisticsSpecialFee/list',
        method: 'get',
        params // get 请求用 params 传递参数（URL 拼接）
    })
}

/**
 * 更新物流特殊费用（含明细）
 * @param {Object} data - 特殊费用更新信息（需携带 id，含 specialFeeDetails 新明细列表）
 * @returns {Promise} - 请求结果
 */
export function updateLogisticsSpecialFee(data) {
    return request({
        url: '/logisticsSpecialFee/update',
        method: 'post',
        data
    })
}

/**
 * 根据特殊费用ID获取明细列表
 * @param {number} specialFeeId - 特殊费用主表ID
 * @returns {Promise} - 明细列表结果
 */
export function getSpecialFeeDetail(specialFeeId) {
    return request({
        url: `/logisticsSpecialFee/getSpecialFeeDetail/${specialFeeId}`, // 路径参数拼接
        method: 'get'
    })
}

/**
 * 批量更新特殊费用状态
 * @param {Object} data - 批量更新参数
 * @param {number[]} data.ids - 特殊费用ID列表
 * @param {number} data.status - 目标状态（0-未发布，1-已发布）
 * @returns {Promise} - 批量更新结果
 */
export function batchUpdateSpecialFeeStatus(data) {
    return request({
        url: '/logisticsSpecialFee/batchUpdateStatus',
        method: 'post',
        data
    })
}


// ==================== 仓库杂费接口（新版，对应 WarehouseMiscFeeController）====================

/**
 * 新增仓库杂费（含明细）
 */
export function addWarehouseMiscFee(data) {
    return request({
        url: '/warehouseMiscFee/add',
        method: 'post',
        data
    })
}

/**
 * 分页查询仓库杂费列表
 */
export function listWarehouseMiscFee(params) {
    return request({
        url: '/warehouseMiscFee/list',
        method: 'get',
        params,
        headers: {
            repeatSubmit: false  // 查询操作允许重复提交
        }
    })
}

/**
 * 更新仓库杂费（含明细）
 */
export function updateWarehouseMiscFee(data) {
    return request({
        url: '/warehouseMiscFee/update',
        method: 'post',
        data
    })
}

/**
 * 根据杂费ID获取明细列表
 */
export function getWarehouseMiscFeeDetail(feeId) {
    return request({
        url: `/warehouseMiscFee/getMiscFeeDetail/${feeId}`,
        method: 'get'
    })
}

/**
 * 批量更新仓库杂费状态
 */
export function batchUpdateWarehouseMiscFeeStatus(data) {
    return request({
        url: '/warehouseMiscFee/batchUpdateStatus',
        method: 'post',
        data
    })
}

/**
 * 单个删除仓库杂费
 */
export function deleteWarehouseMiscFee(id) {
    return request({
        url: `/warehouseMiscFee/delete/${id}`,
        method: 'delete'
    })
}

/**
 * 批量删除仓库杂费
 */
export function batchDeleteWarehouseMiscFee(ids) {
    return request({
        url: '/warehouseMiscFee/batchDelete',
        method: 'post',
        data: ids
    })
}

// ==================== 旧版仓库杂费接口（保留兼容）====================

//保存仓库杂费
export function addMiscellaneous(data) {
    return request({
        url: '/lws/miscellaneous/add',
        method: 'post',
        data
    })
}

//查询仓库杂费
export function getMiscellaneousList(data) {
    return request({
        url: '/lws/miscellaneous/list',
        method: 'post',
        data
    })
}

//删除仓库杂费
export function delMiscellaneousList(data) {
    return request({
        url: '/lws/miscellaneous/del',
        method: 'post',
        data
    })
}

//获取仓库杂费详情（含明细）
export function getMiscellaneousDetail(id) {
    return request({
        url: '/lws/miscellaneous/detail',
        method: 'get',
        params: { id }
    })
}

//修改仓库杂费状态
export function updateMiscellaneousStatus(data) {
    return request({
        url: '/lws/miscellaneous/updateStatus',
        method: 'post',
        data
    })
}
/**
 * 新增物流杂费（含明细）
 */
export function addLogisticsMiscFee(data) {
    return request({
        url: '/logisticsMiscFee/add',
        method: 'post',
        data
    })
}

/**
 * 分页查询物流杂费列表
 */
export function listLogisticsMiscFee(params) {
    return request({
        url: '/logisticsMiscFee/list',
        method: 'get',
        params // get 请求用 params 传递参数（URL 拼接）
    })
}

/**
 * 更新物流杂费（含明细）
 */
export function updateLogisticsMiscFee(data) {
    return request({
        url: '/logisticsMiscFee/update',
        method: 'post',
        data
    })
}

/**
 * 根据杂费规则ID获取明细列表
 */
export function getMiscFeeDetail(miscFeeRuleId) {
    return request({
        url: `/logisticsMiscFee/getMiscFeeDetail/${miscFeeRuleId}`, // 路径参数拼接
        method: 'get'
    })
}

/**
 * 批量更新物流杂费状态
 */
export function batchUpdateMiscFeeStatus(data) {
    return request({
        url: '/logisticsMiscFee/batchUpdateStatus',
        method: 'post',
        data
    })
}
export function batchDeleteLogisticsMiscFee(data){
    return request({
        url: '/logisticsMiscFee/batchDelete',
        method: 'post',
        data
    })
}
export function deleteFeeType(id) {
    return request({
        url: `/feeType/delete/${id}`,
        method: 'delete'
    })
}
export function queryProductsWithInventory(data){
    return request({
        url: '/produce/with-inventory',
        method: 'post',
        data
    })
}

/**
 * 上架：将待上架库存转为可售库存
 */
export function shelvesStock(data) {
    return request({
        url: '/produce/shelves',
        method: 'post',
        data
    })
}

/**
 * 分配出库：将可售库存转为待出库
 */
export function allocateStock(data) {
    return request({
        url: '/produce/allocate',
        method: 'post',
        data
    })
}

/**
 * 确认出库：将待出库转为已出库
 */
export function confirmOutbound(data) {
    return request({
        url: '/produce/confirm-outbound',
        method: 'post',
        data
    })
}

/**
 * 标记不良品
 */
export function markDefective(data) {
    return request({
        url: '/produce/mark-defective',
        method: 'post',
        data
    })
}

export function exportInventoryAll(params) {
    return request({
        url: '/produce/inventory/export/all',
        method: 'get',
        params,
        responseType: 'blob',
        timeout: 60000,
    }).then(response => {
        // 核心修复1：逐层校验 response 和 headers，避免 undefined 取值
        if (!response) {
            throw new Error('导出失败：服务器无响应');
        }
        if (!response.headers) {
            throw new Error('导出失败：响应头为空');
        }

        // 解析文件名（保留原有逻辑，增加兜底）
        const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
        let fileName = `产品库存_${new Date().getTime()}.xlsx`;

        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.*)/);
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]) + '.xlsx';
            }
        }

        // 核心修复2：校验 response.data 存在性
        if (!response.data) {
            throw new Error('导出失败：无导出数据');
        }

        // 生成Blob并下载
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);

        return response;
    }).catch(error => {
        // 核心修复3：解决二进制错误处理的异步问题（改用 Promise 封装）
        return new Promise((_, reject) => {
            console.error('导出失败:', error);
            // 情况1：无响应/响应头异常（同步错误）
            if (!error.response) {
                reject(new Error(error.message || '导出失败：服务器响应异常'));
                return;
            }

            // 情况2：二进制流错误（异步解析）
            const errorData = error.response.data;
            if (errorData instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    const errorText = reader.result || '导出数据量过大或服务器异常';
                    reject(new Error(errorText));
                };
                reader.onerror = () => {
                    reject(new Error('导出失败：无法解析错误信息'));
                };
                reader.readAsText(errorData);
            } else {
                // 情况3：普通错误
                reject(new Error(error.message || '导出失败，请联系管理员'));
            }
        });
    });
}
// 仓租规则主接口
export function getWarehouseRentRuleList(query) {
    return request({
        url: '/warehouseRentRule/list',
        method: 'get',
        params: query
    })
}

export function getAllWarehouseRentRules() {
    return request({
        url: '/warehouseRentRule/list/all',
        method: 'get'
    })
}

export function getWarehouseRentRuleDetail(ruleId) {
    return request({
        url: `/warehouseRentRule/detail/${ruleId}`,
        method: 'get'
    })
}

export function addWarehouseRentRule(data) {
    return request({
        url: '/warehouseRentRule/add',
        method: 'post',
        data
    })
}

export function updateWarehouseRentRule(data) {
    return request({
        url: '/warehouseRentRule/update',
        method: 'post',
        data
    })
}

export function deleteWarehouseRentRule(ruleId) {
    return request({
        url: `/warehouseRentRule/delete/${ruleId}`,
        method: 'delete'
    })
}

export function batchDeleteWarehouseRentRules(ids) {
    return request({
        url: '/warehouseRentRule/batchDelete',
        method: 'delete',
        data: ids
    })
}

//批量审核仓租规则
export function batchAuditWarehouseRentRule(data) {
    return request({
        url: '/warehouseRentRule/batchAudit',
        method: 'post',
        data
    })
}
//批量无效仓租规则
export function batchInvalidWarehouseRentRule(data) {
    return request({
        url: '/warehouseRentRule/batchInvalid',
        method: 'post',
        data
    })
}

// 仓租阶梯规则接口
export function getWarehouseRentLadders(ruleId) {
    return request({
        url: `/warehouseRentLadder/list/${ruleId}`,
        method: 'get'
    })
}

export function addWarehouseRentLadder(data) {
    return request({
        url: '/warehouseRentLadder/add',
        method: 'post',
        data
    })
}

export function updateWarehouseRentLadder(data) {
    return request({
        url: '/warehouseRentLadder/update',
        method: 'post',
        data
    })
}

export function deleteWarehouseRentLadder(ladderId) {
    return request({
        url: `/warehouseRentLadder/delete/${ladderId}`,
        method: 'delete'
    })
}

export function batchSaveWarehouseRentLadders(ruleId, ladders) {
    return request({
        url: `/warehouseRentLadder/batchSave/${ruleId}`,
        method: 'post',
        data: ladders
    })
}

// ===================== 订单拦截相关API =====================

/**
 * 检查订单是否被拦截（用于打包扫描时检查）
 * @param {String} orderNo - 订单号
 */
export function checkOrderIntercept(orderNo) {
    return request({
        url: '/orderIntercept/checkIntercept',
        method: 'get',
        params: { orderNo }
    })
}

/**
 * 标记拦截失败（已打包出库时调用）
 * @param {String} orderNo - 订单号
 * @param {String} remark - 备注
 */
export function markInterceptFailed(orderNo, remark) {
    return request({
        url: '/orderIntercept/markFailed',
        method: 'post',
        params: { orderNo, remark }
    })
}

/**
 * 分页查询拦截记录（WMS拦截管理用）
 * @param {Object} params - { current, size, status }
 */
export function getInterceptList(params) {
    return request({
        url: '/orderIntercept/list',
        method: 'get',
        params
    })
}

/**
 * 完成拦截操作（WMS确认拦截成功）
 * @param {String} orderNo - 订单号
 * @param {String} completeBy - 完成操作人
 * @param {Boolean} success - 是否成功
 * @param {String} remark - 备注
 */
export function completeOrderIntercept(orderNo, completeBy, success, remark) {
    return request({
        url: '/orderIntercept/complete',
        method: 'post',
        params: { orderNo, completeBy, success, remark }
    })
}

/**
 * 根据订单号查询拦截记录
 * @param {String} orderNo - 订单号
 */
export function getInterceptByOrderNo(orderNo) {
    return request({
        url: '/orderIntercept/getByOrderNo',
        method: 'get',
        params: { orderNo }
    })
}

// ==================== 充值审核管理相关接口 ====================

/**
 * WMS - 查询充值记录列表
 * @param {Object} params - 查询参数
 */
export function getRechargeList(params) {
    return request({
        url: '/wms/recharge/list',
        method: 'get',
        params
    })
}

/**
 * WMS - 根据ID查询充值记录详情
 * @param {Number} id - 充值记录ID
 */
export function getRechargeById(id) {
    return request({
        url: `/wms/recharge/${id}`,
        method: 'get'
    })
}

/**
 * WMS - 审核充值记录
 * @param {Object} data - 审核数据 { id, status, auditRemark }
 */
export function auditRecharge(data) {
    return request({
        url: '/wms/recharge/audit',
        method: 'post',
        data
    })
}

/**
 * WMS - 批量审核充值记录
 * @param {Array} data - 审核数据数组
 */
export function batchAuditRecharge(data) {
    return request({
        url: '/wms/recharge/audit/batch',
        method: 'post',
        data
    })
}

/**
 * WMS - 删除充值记录
 * @param {Array|String} ids - 充值记录ID数组或单个ID
 */
export function deleteRecharge(ids) {
    return request({
        url: `/wms/recharge/${ids}`,
        method: 'delete'
    })
}

// ==================== 退件单相关接口 ====================

/**
 * 根据跟踪号查询退件单（用于到仓扫描）
 * @param {String} trackingNo - 跟踪号
 */
export function getReturnOrderByTrackingNo(trackingNo) {
    return request({
        url: '/returnOrder/getByTrackingNo',
        method: 'get',
        params: { trackingNo }
    })
}

/**
 * 根据扫描码查询退件单（支持订单号、跟踪号、退件单号、参考号）
 * @param {String} scanCode - 扫描码
 */
export function getReturnOrderByScanCode(scanCode) {
    return request({
        url: '/returnOrder/getByScanCode',
        method: 'get',
        params: { scanCode }
    })
}

/**
 * 确认退件单收货
 * @param {Object} data - { returnNo, receiveBy, receiveRemark }
 */
export function confirmReturnOrderReceive(data) {
    return request({
        url: '/returnOrder/confirmReceive',
        method: 'post',
        data
    })
}

/**
 * 确认退件单收货并更新实收数量
 * @param {Object} data - 退件单信息（包含明细的实收数量）
 */
export function confirmReturnOrderReceiveWithQuantity(data) {
    return request({
        url: '/returnOrder/confirmReceiveWithQuantity',
        method: 'post',
        data
    })
}

/**
 * 退件单上架处理
 * @param {String} returnNo - 退件单号
 * @param {String} operateBy - 操作人
 */
export function processReturnOrderShelves(returnNo, operateBy) {
    return request({
        url: '/returnOrder/processShelves',
        method: 'post',
        params: { returnNo, operateBy }
    })
}

/**
 * 退件单上架处理（带库位信息）
 * @param {Object} data - { returnNo, operateBy, items: [{ id, productSku, locationCode, locationId, quantity }] }
 */
export function processReturnOrderShelvesWithLocation(data) {
    return request({
        url: '/returnOrder/processShelvesWithLocation',
        method: 'post',
        data
    })
}